import styled, { css } from "styled-components"
import { fieldStyles } from "../styles"

export const StyledField = styled.input`
  position: relative;
  ${fieldStyles}
`

export const EyeIcon = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding-right: 1rem;
  color: #ccc;
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: ${({ theme }) => theme.colors.brand};
  }

  ${({ showPassword }) =>
    !!showPassword &&
    css`
      color: ${({ theme }) => theme.colors.brand};
    `}

  svg {
    width: 1rem;
    height: 1rem;
  }
`
export const PasswordWrapper = styled.div`
  position: relative;
`
